import { Card, Flex, Stack, Alert, LoadingOverlay } from '@mantine/core';
import { BaseRecord } from '@refinedev/core';
import { IconExclamationCircle } from '@tabler/icons-react';

import {
  MRT_EditActionButtons,
  MRT_Row,
  MRT_TableInstance,
} from 'mantine-react-table';

import React from 'react';

interface EditModalProps<TData extends BaseRecord> {
  type: string;
  row: MRT_Row<TData>;
  table: MRT_TableInstance<TData>;
  internalEditComponents?: React.ReactNode[];
  alertModal?: boolean;
  isLoading?: boolean;
}

export const EditModal = <TData extends BaseRecord>({
  type,
  row,
  table,
  internalEditComponents = [],
  alertModal = false,
  isLoading = false,
}: EditModalProps<TData>) => {
  return (
    <Card shadow="md" radius="md" padding="md">
      <LoadingOverlay visible={isLoading} />
      <Stack data-testid={`edit-${type}-modal`}>
        {alertModal ? (
          <Alert
            icon={<IconExclamationCircle />}
            title="Form Errors"
            color={'red'}
            children={'Fix the form errors to submit.'}
            withCloseButton
            closeButtonLabel="Close alert"
            data-testid="alertModal"
          />
        ) : (
          <></>
        )}
        {internalEditComponents}
        <Flex justify="end">
          <MRT_EditActionButtons row={row} table={table} variant="text" />
        </Flex>
      </Stack>
    </Card>
  );
};
